interface ReleaseNoteTextProps {
  text: string;
}

export const ReleaseNoteText = ({ text }: ReleaseNoteTextProps) => (
  <span style={{ whiteSpace: "pre-line" }}>
    {text.split(/(\*\*[^*]+\*\*)/g).map((part, index) => {
      const boldText = /^\*\*(.+)\*\*$/.exec(part)?.[1];
      return boldText ? <strong key={index}>{boldText}</strong> : <span key={index}>{part}</span>;
    })}
  </span>
);
